"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getSettingsValues = void 0;
var getSettingsValue_1 = require("./getSettingsValue");
function getSettingsValues(values, params, options) {
    if (options === void 0) { options = {}; }
    var acc = {};
    Object.keys(params).forEach(function (paramKey) {
        var param = params[paramKey];
        acc[param.key] = getSettingsValue_1.getSettingsValue(values, param, options);
    });
    return acc;
}
exports.getSettingsValues = getSettingsValues;
//# sourceMappingURL=getSettingsValues.js.map